import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { digitsOnly } from 'core/validators';
import { decimalOnly } from 'helpers';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[decimalMask]'
})
export class DecimalMaskDirective {
  constructor(private el: ElementRef, private control: NgControl) {
  }

  @HostListener('keyup', ['$event']) onKeydown($event: KeyboardEvent) {
    if ($event.key === 'Backspace' || $event.key === 'Delete') {
      return;
    } else {
      this.updateValue();
    }
  }

  private updateValue() {
    const value = this.el.nativeElement.value;
    const formattedValue =  decimalOnly(value);
    this.control.control.setValue(formattedValue);
  }
}
